import useSiteConfiguration from '@frontend/libs/hooks/useSiteConfiguration'
import { Button, Skeleton } from '@nextui-org/react'

import AppleIcon from './components/AppleIcon'
import FacebookIcon from './components/FacebookIcon'
import GoogleIcon from './components/GoogleIcon'
import LineIcon from './components/LineIcon'

type SocialLoginProps = {
  appleButtonText?: string
  facebookButtonText?: string
  googleButtonText?: string
  lineButtonText?: string
}

function SocialLogin({
  appleButtonText = 'Continue with Apple',
  facebookButtonText = 'Continue with Facebook',
  googleButtonText = 'Continue with Google',
  lineButtonText = 'Continue with Line',
}: Readonly<SocialLoginProps>) {
  const { isLoading, settings } = useSiteConfiguration()

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-9 w-full" />
        <Skeleton className="h-9 w-full" />
      </div>
    )
  }

  return (
    <div className="space-y-2">
      {settings?.socialLogin.facebook && (
        <Button
          as={`a`}
          color="primary"
          fullWidth
          href="/auth/facebook"
          size="lg"
          startContent={<FacebookIcon />}
          variant="bordered"
        >
          <span>{facebookButtonText}</span>
        </Button>
      )}
      {settings?.socialLogin.google && (
        <Button
          as={`a`}
          color="primary"
          fullWidth
          href="/auth/google"
          size="lg"
          startContent={<GoogleIcon />}
          variant="bordered"
        >
          <span>{googleButtonText}</span>
        </Button>
      )}
      {settings?.socialLogin.apple && (
        <Button
          as={`a`}
          color="primary"
          fullWidth
          href="/auth/apple"
          size="lg"
          startContent={<AppleIcon />}
          variant="bordered"
        >
          <span>{appleButtonText}</span>
        </Button>
      )}
      {settings?.socialLogin.line && (
        <Button
          as={`a`}
          color="primary"
          fullWidth
          href="/auth/line"
          size="lg"
          startContent={<LineIcon />}
          variant="bordered"
        >
          <span>{lineButtonText}</span>
        </Button>
      )}
    </div>
  )
}

export default SocialLogin
